import { useCallback, useEffect, useState } from "react";
// import { Share2, MoreVertical } from "lucide-react";
import { Share, MoreVert } from '@mui/icons-material';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TeslaGallery from "../components/TeslaGallery";
import ShareBuy from "../components/ShareBuy";
import UberOffer from "../components/UberOffer";
import imagesPath from "../data/imagesPath";

type CompanyData = {
  img1: string;
  img2: string;
  img3: string;
  banner: string;
  company: string;
  desc: string;
  point1: string;
  point2: string;
};

// Company data is imported from imagesPath

export default function DetailsPage() {
  const { company } = useParams();
  const [data, setData] = useState<CompanyData | null>(null);
  const { shares } = useLocation().state || {};

  const formatCompany = useCallback((name: string) => {
    return name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }, []);

  useEffect(() => {
    if (company) {
      const formattedCompany = formatCompany(company);
      const filteredData = imagesPath.filter(
        (item) => item.company.toLowerCase() === formattedCompany.toLowerCase()
      );
      if (filteredData.length > 0) {
        setData(filteredData[0]);
      } else {
        navigate("/votr-access");
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, formatCompany]);

  const navigate = useNavigate();

  if (!data) {
    return (
      <div className="min-h-screen bg-[#fafafa] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#C2101F] mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#fafafa]">
      <div
        className="h-auto bg-cover bg-center pt-4  relative"
        style={{
          background: `linear-gradient(180deg, #18010a 0%, rgba(24, 1, 10, 0.95) 50%, rgba(24, 1, 10, 0.9) 100%)`,
          minHeight: '200px'
        }}
      >
      </div>

      {/* Navigation section */}
      <div className="w-full max-w-7xl mx-auto relative">
        <div className="max-w-7xl mx-auto absolute top-[-210px] md:top-[-160px]">
          <div className="max-w-7xl mx-auto pb-6 pt-6 md:pt-0 px-4 xl:px-0">
            {/* Header section */}
            <div className="flex items-center justify-between w-full gap-2 mb-4">
              <div className="w-full flex items-center justify-between">
                <div className="text-lg">
                  <div
                    onClick={() => navigate("/votr-access")}
                    className="text-[#C2101F] flex items-center gap-2 cursor-pointer"
                  >
                    <svg
                      className="h-5 w-5 transition-transform rotate-90"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                    <span>Back</span>
                  </div>
                  <div className="flex flex-col gap-3 sm:flex-row">
                    <div className="text-xl text-white font-medium md:text-3xl">
                      {data.company} Early Access
                    </div>
                  </div>
                  <div className="text-white pt-2 text-sm font-normal">
                    <span className="text-[#6B6B6B]">Date Created : </span>
                    <span>30 August 2025</span>
                  </div>
                </div>
              </div>
              <div className="hidden lg:flex items-center gap-2">
                <button className="text-white border border-white/30 rounded-full p-2 bg-white/10">
                  <Share className="h-5 w-5" />
                </button>
                <button className="text-white border border-white/30 rounded-full p-2 bg-white/10">
                  <MoreVert className="h-5 w-5" />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Left column - Image Gallery and Description */}
              <TeslaGallery company={data?.company} />
              
              {/* Right column - Eligibility and Action */}
              <ShareBuy company={data?.company} shares={shares} />
            </div>

            <div className="mt-12">
              <h3 className="text-black font-semibold text-2xl mb-6">Similar Offers</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <UberOffer
                  logo={data?.img1}
                  name={data?.company?.toUpperCase()}
                  title="10% off iPhone 16 for shareholders with 50+ shares"
                  image="/access/offerImage1.png"
                />
                <UberOffer
                  logo={data?.img1}
                  name={data?.company?.toUpperCase()}
                  title="Complimentary Uber One for shareholders with 100+ shares"
                  image="/offerImage2.png"
                />
                <UberOffer
                  logo={data?.img1}
                  name={data?.company?.toUpperCase()}
                  title="Complimentary service upgrade for shareholders with 100+ shares"
                  image="/offerImage3.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
